<ng-container *ngIf="init">
    <router-outlet></router-outlet>
</ng-container>